import React from 'react';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from '@material-ui/core/Button';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import AddLogForm from './AddLogForm';

class LogsDialog extends React.Component {
  render() {
    return (
      <Dialog
        fullScreen={this.props.fullScreen}
        open={this.props.open}
        onClose={this.props.toggleOpen}
        disableBackdropClick
        aria-labelledby="logs-dialog"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="logs-dialog">
          <h3 style={{ textAlign: 'center', margin: 0 }}>Add Log</h3>
        </DialogTitle>

        <DialogContent>
          <AddLogForm onSubmit={this.props.createOrUpdateLog} />
        </DialogContent>

        <DialogActions style={{ display: 'block', padding: '0 10px' }}>
          <FlatButton
            onClick={this.props.toggleOpen}
            id="close-button"
            style={{ color: AccentColor(), padding: '0 15px' }}
          >
            CLOSE
          </FlatButton>

          <FlatButton
            onClick={this.props.submit}
            id="submit-button"
            disabled={this.props.disabled}
            style={{
              color: 'white',
              padding: '0 15px',
              backgroundColor: this.props.disabled ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            SAVE
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(LogsDialog);
